<template>
  <div class="login-warp">
    <!-- <div class="login-bg">
      <img src="../../assets/imgs/img_logo.png" alt="" />
    </div> -->
    <div class="login-form">
      <!-- <h1>{{ $t('login.welcome', { appname: appName }) }}</h1> -->
      <div class="logo">
        <img src="../../assets/imgs/img_logo.png" alt="" />
      </div>
      <div class="login-type">
        <span :class="{ 'select': loginType === 'SMS' }" @click="loginType = 'SMS'">SMS</span>
        <span :class="{ 'select': loginType === 'Email' }" @click="loginType = 'Email'">Email</span>
      </div>
      <van-form>
        <div v-if="loginType === 'SMS'" class="login-row">
          <div class="area" @click="isAreaView = true">
            <span>+{{ areaCode }}</span>
            <div class="area-down"></div>
          </div>
          <input type="number" v-model="phone" :placeholder="i18n.phone_number" />
        </div>
        <div v-else class="login-row">
          <input type="email" v-model="email" :placeholder="i18n.email" />
          <!-- <img class="login-go" src="../../assets/imgs/icon_next.png" alt="" @click="onSendCodeEmail" /> -->
        </div>
        <div v-if="loginType === 'SMS'" class="login-row">
          <input type="number" v-model="code" :placeholder="i18n.captcha_code" />
          <div class="login-code" @click="onCaptcha">
            <img :src="captchaUrl" />
          </div>
        </div>
        <!-- <div class="login-row">
          <input type="text" v-model="email" :placeholder="i18n.email">
        </div> -->
        <div class="login-info">
          <span
            >{{ i18n.agree }}
            <span class="readme" @click="onReadMe">{{ i18n.readme }}</span>
          </span>
        </div>
        <div class="btn login-btn" @click="sendBefore">{{ i18n.login }}</div>
      </van-form>
      <div class="login-foot">
        <div class="login-foot-tips">
          <span>{{ i18n.sign_in_with }}</span>
        </div>
        <div class="login-foot-imgs">
          <!-- <login-facebook @success="loadUser">
            <img src="../../assets/imgs/icon_facebook.png" alt=""/>
          </login-facebook> -->
          <login-google @success="loadUser">
            <div id="buttonDiv"></div>
            <!-- <img src="../../assets/imgs/icon_google.png" alt=""> -->
          </login-google>
        </div>
      </div>
    </div>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
    <login-code
      v-if="isLoginCode"
      :loginType="loginType"
      @submit="loginBefore"
      @again="onBack"
      @back="onBack"
    ></login-code>
  </div>
</template>

<script>
import { SelectArea } from "../../components/select"
import { generateUUID } from "../../utils/index"
import { baseURL } from "../../utils/http"
import { USER_CAPTCHA, LOGIN_CODE, SEND_CODE, USER_INFO, SEND_CODE_EMAIL, LOGIN_EMAIL } from "../../apis/user"
import { LoginCode, LoginGoogle, LoginFacebook } from "../../components/login"
import { mapState } from "vuex"
import md5 from 'js-md5'
import i18n from "../../i18n"

export default {
  components: {
    SelectArea,
    LoginCode,
    // LoginFacebook,
    LoginGoogle
  },
  computed: {
    ...mapState(["user", "browser"]),
    i18n() {
      return this.$t("login")
    },
    appName () {
      return process.env.VUE_APP_NAME
    }
  },
  watch: {
    user(val, oldVal) {
      if (val && !oldVal) {
        this.$router.push("/")
      }
    },
    loginType(val) {
      if (val === "SMS") {
        this.onCaptcha()
      }
    }
  },
  data() {
    return {
      email: "",
      isAreaView: false,
      areaCode: "52",
      phone: "",
      code: "",
      captchaUrl: "",
      uuid: "",
      isLoginCode: false,
      loginType: 'SMS'
    }
  },
  methods: {
    onReadMe() {
      const VUE_APP_PACT = `${process.env.VUE_APP_DOMAIN}/content/user_agreement.html`
      window.open(VUE_APP_PACT)
    },
    onSelct(val) {
      this.areaCode = val
    },
    onCaptcha() {
      this.code = ""
      this.uuid = generateUUID()
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    },
    sendBefore () {
      if (this.loginType === 'SMS') {
        this.onSendCode()
      } else {
        this.onSendCodeEmail()
      }
    },
    loginBefore (code) {
      if (this.loginType === 'SMS') {
        this.onLogin(code)
      } else {
        this.onLoginEmail(code)
      }
    },
    onLogin(code) {
      this.$loading(true)
      this.$post(
        LOGIN_CODE,
        {
          mobile: this.areaCode + this.phone,
          verifyCode: code,
          areaCode: this.areaCode,
          registAndLoginType: 1
        },
        (res) => {
          console.log(res)
          this.$loading(false)
          if (res.token) {
            this.$store.commit("token", res.token)
            this.loadUser()
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        (err) => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onSendCode() {
      let regex = /^\d{6,}$/
      if (!regex.test(this.phone)) {
        this.$toast(this.i18n.phone_format_tips);
        return;
      }
      this.$loading(true)
      this.$post(
        SEND_CODE,
        {
          mobile: this.areaCode + this.phone,
          uuid: this.uuid,
          code: this.code,
          useDebug: false
        },
        (res) => {
          console.log(res)
          this.$loading(false)
          this.isLoginCode = true
        },
        (err) => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
          this.onCaptcha()
        }
      )
    },
    onBack() {
      this.isLoginCode = false
      this.onCaptcha()
    },
    loadUser() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (res) => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit("user", res.user)
            this.$toast(this.i18n.msg_success_login)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser()
              })
              .catch(() => {
                this.$store.commit("token", null)
              })
          }
        },
        (err) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null)
          })
        }
      )
    },
    onSendCodeEmail() {
      if (!this.email) {
        this.$toast(this.i18n.verification_email)
        return
      }
      this.$loading(true)
      var timestamp = Math.floor(Date.now() / 1000)
      this.$get(
        SEND_CODE_EMAIL,
        {
          email: this.email,
          timestamp: timestamp,
          sign: md5(timestamp.toString().replaceAll("0", "8") + "GZzbjkj")
        },
        res => {
          console.log(res)
          this.$loading(false)
          this.isLoginCode = true
        },
        err => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onLoginEmail(code) {
      this.$loading(true)
      this.$post(
        LOGIN_EMAIL,
        {
          email: this.email,
          verifyCode: code
        },
        res => {
          console.log(res)
          this.$loading(false)
          if (res.token) {
            this.$store.commit('token', res.token)
            this.loadUser()
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        err => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        }
      )
    }
  },
  created() {
    if (this.browser === "wechat") {
      this.$router.push("/login_wechat")
    } else if (this.browser === "alipay") {
      this.$router.push("/login_alipay")
    }
    // const langCode = window.navigator.language.substring(3)
    // let temp = AreaCodeDate.find(item => item.code === langCode)
    // if (temp && temp.value) {
    //   this.areaCode = temp.value
    // }
  },
  mounted() {
    this.onCaptcha()
  }
}
</script>

<style lang="less">
@mainColor: #FF4E00;
@cardColor: #000000;
.login-warp {
  width: 100%;
  height: 100vh;
  background-color: #000;
  // background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 43%, rgba(28,218,247,0.7) 100%);
    // background: #000000;
  color: #fff;
  position: relative;
  .login-bg {
    width: 100%;
    position: absolute;
    top: 60px;
    img {
      display: block;
      margin: 60px auto;
      width: 40%;
    }
  }
  .logo {
    padding: 0 0 40px 0;
    img {
      display: block;
      margin: 0 auto;
      width: 322px;
    }
  }
  .login-form {
    position: absolute;
    width: 100%;
    height: 90%;
    bottom: 0;
    // background: @cardColor;
    color: #fff;
    border-top-left-radius: 80px;
    border-top-right-radius: 80px;
    padding-top: 34px;
    h1 {
      padding: 0 40px;
      font-size: 70px;
    }
    .login-type {
      display: flex;
      justify-content: center;
      span {
        display: block;
        padding: 10px 40px;
        border-radius: 20px;
        margin-top: 40px;
        margin-left: 20px;
      }
      .select {
        background: @mainColor;
        color: #fff;
      }
    }
  }

  .login-row {
    margin: 36px 96px;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 4px solid @mainColor;
    border-radius: 10px;
    padding: 0 20px;
    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }

    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: #fff transparent transparent;
    }

    .login-code {
      width: 180px;
      height: 60px;
      background-image: linear-gradient(
        to right,
        rgba(194, 194, 194, 1),
        rgba(252, 252, 252, 1)
      );
      margin-right: 20px;

      img {
        width: 180px;
        height: 60px;
      }
    }
  }

  .btn {
    margin: 60px 96px 0;
  }

  .login-foot {
    position: fixed;
    left: 96px;
    right: 96px;
    bottom: 48px;
    // margin: 60px 0;

    &-tips {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      span {
        z-index: 88;
        color: #666;
        // background: @cardColor;
        padding: 28px;
      }

      &::after {
        // position: absolute;
        // left: 5%;
        content: " ";
        height: 1px;
        width: 25%;
        background-color: @mainColor;
        z-index: 87;
      }
      &::before {
        // position: absolute;
        // left: 5%;
        content: " ";
        height: 1px;
        width: 25%;
        background-color: @mainColor;
        z-index: 87;
      }
    }

    &-imgs {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 60px;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  .login-info {
    font-size: 24px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 33px;
    display: flex;
    justify-content: flex-start;
    padding: 0 96px;
  }

  .login-info .readme {
    font-weight: 500;
    color: rgba(52, 125, 255, 1);
    margin-left: 10px;
    display: inline;
  }
   .login-btn {
     background: linear-gradient( 90deg, #FDE400 0%, #FF4E00 100%);
     color: #000;
   }
}
</style>
